import { formatDateTimeToShowUser } from 'features/common/helpers';
import { ITransactionFinalization } from '../types';
import { formatTransactionAmount } from 'features/transaction-details/helpers';

export const sortFinalizationsChronologically = (items: ITransactionFinalization[]): ITransactionFinalization[] =>
	[...items].sort((a, b) => new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime());

export const formatFinalizationWhen = (createdAt: string): string => {
	const formatted = formatDateTimeToShowUser(createdAt);
	const [datePart, timePart] = formatted.split(' ');
	if (datePart && timePart) {
		return `${datePart} a las ${timePart.substring(0, 5)}`;
	}
	return formatted;
};

export const formatFinalizationColloquialLine = (
	finalization: ITransactionFinalization,
	index: number,
	coinCode: string,
): string => {
	const before = formatTransactionAmount(finalization.amountBeforeFinalize, coinCode);
	const after = formatTransactionAmount(finalization.amountAuthorizedAtFinalize, coinCode);
	const when = formatFinalizationWhen(finalization.createdAt);

	if (index === 0) {
		return `Arrancó en ${before} y la bajamos a ${after} el ${when}.`;
	}

	return `Después la ajustamos de ${before} a ${after} el ${when}.`;
};

export const formatFinalizationLine = (
	finalization: ITransactionFinalization,
	index: number,
	coinCode: string,
): string => {
	const before = formatTransactionAmount(finalization.amountBeforeFinalize, coinCode);
	const after = formatTransactionAmount(finalization.amountAuthorizedAtFinalize, coinCode);
	const when = formatFinalizationWhen(finalization.createdAt);
	const who = finalization.createdBy;

	if (index === 0) {
		return `Esta transacción originalmente era por ${before} y fue finalizada en ${after} el ${when} por ${who}.`;
	}

	return `Se ajustó de ${before} a ${after} el ${when} por ${who}.`;
};
